import type { IncidentTimeRange } from './useIncidentsTimeRange';

export type HeatmapOccurrenceWindow = {
  fromDate: string;
  toDate: string;
};

export function resolveHeatmapOccurrenceWindow(
  timeRange: IncidentTimeRange,
  heatmapWindow?: Partial<HeatmapOccurrenceWindow> | null,
): HeatmapOccurrenceWindow | null {
  const fromDate = String(timeRange.fromDate || heatmapWindow?.fromDate || '').trim();
  const toDate = String(timeRange.toDate || heatmapWindow?.toDate || '').trim();
  if (fromDate && toDate) {
    return { fromDate, toDate };
  }
  const to = new Date();
  const from = new Date(to.getTime() - 7 * 24 * 60 * 60 * 1000);
  return { fromDate: from.toISOString(), toDate: to.toISOString() };
}
